"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetImpressionAndBDLCheckResponseToJSON = exports.GetImpressionAndBDLCheckResponseFromJSONTyped = exports.GetImpressionAndBDLCheckResponseFromJSON = exports.instanceOfGetImpressionAndBDLCheckResponse = void 0;
var runtime_1 = require("../runtime");
var AdSetImpressionResponse_1 = require("./AdSetImpressionResponse");
/**
 * Check if a given object implements the GetImpressionAndBDLCheckResponse interface.
 */
function instanceOfGetImpressionAndBDLCheckResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetImpressionAndBDLCheckResponse = instanceOfGetImpressionAndBDLCheckResponse;
function GetImpressionAndBDLCheckResponseFromJSON(json) {
    return GetImpressionAndBDLCheckResponseFromJSONTyped(json, false);
}
exports.GetImpressionAndBDLCheckResponseFromJSON = GetImpressionAndBDLCheckResponseFromJSON;
function GetImpressionAndBDLCheckResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adSetEstimates': !(0, runtime_1.exists)(json, 'ad_set_estimates') ? undefined : (json['ad_set_estimates'].map(AdSetImpressionResponse_1.AdSetImpressionResponseFromJSON)),
    };
}
exports.GetImpressionAndBDLCheckResponseFromJSONTyped = GetImpressionAndBDLCheckResponseFromJSONTyped;
function GetImpressionAndBDLCheckResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_set_estimates': value.adSetEstimates === undefined ? undefined : (value.adSetEstimates.map(AdSetImpressionResponse_1.AdSetImpressionResponseToJSON)),
    };
}
exports.GetImpressionAndBDLCheckResponseToJSON = GetImpressionAndBDLCheckResponseToJSON;
